import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { Table, Input, Space } from 'antd';
import { SearchRounded, RestartAltRounded, ManageSearchRounded } from "@mui/icons-material";

const SearchableTable = ({ columns, data, rowSelection, className = '', ...props }) => {
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [visibleFilter, setVisibleFilter] = useState(false);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
    setSearchedColumn('');
    setVisibleFilter(false);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            startIcon={<SearchRounded />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            startIcon={<RestartAltRounded />}
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => <ManageSearchRounded sx={{ color: filtered ? '#1890ff' : '#ccc' }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : false,
  });

  const searchableColumns = columns.map((col) => ({
    ...col,
    ...(col.searchable ? getColumnSearchProps(col.dataIndex) : {}),
  }));

  return (
    <div className="table-container">
      <Table
        columns={searchableColumns}
        dataSource={data}
        rowSelection={rowSelection}
        className={`custom-table ${className}`}
        pagination={{
          defaultPageSize: 50,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30', '50', '100', '250'],
        }}
        {...props}
      />
      <style jsx global>{`
        .table-container .ant-table-thead > tr > th {
          background: #fafafa;
          position: sticky;
          top: 0;
          z-index: 2;
        }
        
        .table-container .ant-table-thead > tr > th.ant-table-selection-column {
          z-index: 3;
        }
        
        .table-container .ant-table-tbody > tr.ant-table-row-selected > td {
          background: #e6f7ff;
        }
        
        .custom-table {
          overflow: auto;
        }
        
        .table-container .ant-table-container {
          border-radius: 8px;
          border: 1px solid #f0f0f0;
        }
      `}</style>
    </div>
  );
};

export default SearchableTable;